import {Outlet} from 'react-router-dom'
import React from 'react'

export const PublicLayout: React.FC = () => {
    return <Outlet />
}
